import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout';

import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import ArchiveList from './pages/ArchiveList';
import EventDetail from './pages/EventDetail';
import EventInfo from './pages/EventInfo';
import MyTickets from './pages/MyTickets';
import FoodRuns from './pages/FoodRuns';
import Gallery from './pages/Gallery';
import GalleryAlbum from './pages/GalleryAlbum';
import FoodRunDetail from './pages/FoodRunDetail';
import SeatMap from './pages/SeatMap';
import Profile from './pages/Profile';
import PublicProfile from './pages/PublicProfile';
import ResetPassword from './pages/ResetPassword';

import TournamentDetail from './pages/TournamentDetail';
import SponsorShow from './pages/SponsorShow';
import BingoCard from './pages/BingoCard';
import BingoShow from './pages/BingoShow';
import TimetableShow from './pages/TimetableShow';
import BracketShow from './pages/BracketShow';
import AdminBingo from './pages/admin/AdminBingo';
import MyTournaments from './pages/MyTournaments';
import TeamDetail from './pages/TeamDetail';
import MatchDetail from './pages/MatchDetail';

import AdminLayout from './pages/admin/AdminLayout';
import Dashboard from './pages/admin/Dashboard';
import AdminEvents from './pages/admin/AdminEvents';
import AdminTimetable from './pages/admin/AdminTimetable';
import AdminTickets from './pages/admin/AdminTickets';
import AdminPayments from './pages/admin/AdminPayments';
import AdminNewsletter from './pages/admin/AdminNewsletter';
import AdminSeats from './pages/admin/AdminSeats';
import AdminCatering from './pages/admin/AdminCatering';
import AdminCheckin from './pages/admin/AdminCheckin';
import AdminTournaments from './pages/admin/AdminTournaments';
import AdminTournamentDetail from './pages/admin/AdminTournamentDetail';
import AdminSponsors from './pages/admin/AdminSponsors';
import AdminUsers from './pages/admin/AdminUsers';
import AdminLogs from './pages/admin/AdminLogs';
import AdminLinks from './pages/admin/AdminLinks';
import AdminInfo from './pages/admin/AdminInfo';
import InfoShow from './pages/InfoShow';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/login" element={<Layout><Login /></Layout>} />
          <Route path="/register" element={<Layout><Register /></Layout>} />
          <Route path="/info" element={<Layout><EventInfo /></Layout>} />
          <Route path="/archiv" element={<Layout><ArchiveList /></Layout>} />
          <Route path="/events" element={<Navigate to="/archiv" replace />} />
          <Route path="/events/:id" element={<Layout><EventDetail /></Layout>} />
          <Route path="/events/:eventId/seats" element={<Layout><SeatMap /></Layout>} />
          <Route path="/my-tournaments" element={<Layout><MyTournaments /></Layout>} />
          <Route path="/tournaments/:id" element={<Layout><TournamentDetail /></Layout>} />
          <Route path="/teams/:id" element={<Layout><TeamDetail /></Layout>} />
          <Route path="/matches/:id" element={<Layout><MatchDetail /></Layout>} />
          <Route path="/my-tickets" element={<Layout><MyTickets /></Layout>} />
          <Route path="/food-runs" element={<Layout><FoodRuns /></Layout>} />
          <Route path="/food-runs/:id" element={<Layout><FoodRunDetail /></Layout>} />
          <Route path="/galerie" element={<Layout><Gallery /></Layout>} />
          <Route path="/galerie/:id" element={<Layout><GalleryAlbum /></Layout>} />
          <Route path="/profile" element={<Layout><Profile /></Layout>} />
          <Route path="/users/:id" element={<Layout><PublicProfile /></Layout>} />
          <Route path="/reset-password" element={<Layout><ResetPassword /></Layout>} />

          <Route path="/admin" element={<Layout><AdminLayout /></Layout>}>
            <Route index element={<Dashboard />} />
            <Route path="events" element={<AdminEvents />} />
            <Route path="timetable" element={<AdminTimetable />} />
            <Route path="tickets" element={<AdminTickets />} />
            <Route path="payments" element={<AdminPayments />} />
            <Route path="newsletter" element={<AdminNewsletter />} />
            <Route path="seats" element={<AdminSeats />} />
            <Route path="catering" element={<AdminCatering />} />
            <Route path="tournaments" element={<AdminTournaments />} />
            <Route path="tournaments/:id" element={<AdminTournamentDetail />} />
            <Route path="checkin" element={<AdminCheckin />} />
            <Route path="sponsors" element={<AdminSponsors />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="logs" element={<AdminLogs />} />
            <Route path="bingo" element={<AdminBingo />} />
            <Route path="links" element={<AdminLinks />} />
            <Route path="info" element={<AdminInfo />} />
          </Route>

          <Route path="/sponsor-show" element={<SponsorShow />} />
          <Route path="/bingo-show" element={<BingoShow />} />
          <Route path="/bingo/:token" element={<BingoCard />} />
          <Route path="/timetable-show/:eventId" element={<TimetableShow />} />
          <Route path="/bracket-show/:id" element={<BracketShow />} />
          <Route path="/info-show" element={<InfoShow />} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
